import React from 'react';
import { chatStyles, MessageBodyProps } from '@zonofi/chats-common';
import { extractLinks, theme } from '@zonofi/common';
import DOMPurify from 'dompurify';
import Parser from 'html-react-parser';

export const MessageBody: React.FC<MessageBodyProps> = ({ text }) => {
  if (text.length === 0) return null;
  const parts = (text || '')?.split(/(\*.*?\*|_.*?_)/g) || [];

  return (
    <div
      className="message-body comms-font-size-regular"
      style={chatStyles.fontRegular14Primary}
    >
      {parts.map((part, index) => {
        if (part.startsWith('*') && part.endsWith('*')) {
          return (
            <span key={index} style={theme.fontConfig.semiBold}>
              {renderTextWithLinks(part.slice(1, -1))}
            </span>
          );
        } else if (part.startsWith('_') && part.endsWith('_')) {
          return (
            <span
              key={index}
              style={{ fontStyle: 'italic', ...theme.fontConfig.regular }}
            >
              {renderTextWithLinks(part.slice(1, -1))}
            </span>
          );
        } else {
          return (
            <span key={index} style={theme.fontConfig.regular}>
              {renderTextWithLinks(part)}
            </span>
          );
        }
      })}
    </div>
  );
};

const renderTextWithLinks = (
  text: string
): string | JSX.Element | JSX.Element[] => {
  const links = extractLinks(text);
  let messageText = DOMPurify.sanitize(text);
  if (links) {
    links.forEach((link) => {
      const anchorTag = `<a href="${link}" target="_blank">${link}</a>`;
      messageText = messageText.replace(link, anchorTag);
    });
  }
  return Parser(messageText);
};
